module.exports = __webpack_public_path__ + "media/images/favicons/twilioimpactcorps-31f2509a38f81a88e407191cbfe766d5b71821f550e992357dcc104349339dd6.ico";